;var SearchCards = function( content ) {
  var words = $( '.search #search' ).val().toLowerCase();
  words = RemoveLatinCharacters( words ).split(' ');

  $.each( content, function( i ) {
    var query = '';

    var name = content[i].nome;
    if ( name ) {
      query += RemoveLatinCharacters( name.toLowerCase() );
    }

    var data = content[i].nascimento.data;
    if ( data ) {
      query += RemoveLatinCharacters( data.toLowerCase() );
    }


    /*var fullName = content[i].nome_completo;
    if ( fullName ) {
      query += ' ' + RemoveLatinCharacters( fullName.toLowerCase() );
    }

    var description = content[i].descricao;
    if ( description ) {
      query += ' ' + RemoveLatinCharacters( description.toLowerCase() );
    }*/

    if ( query ) {
      content[i].filtered = true;
      for ( var j = 0; j < words.length; j++ ) {
        if ( query.indexOf( words[j] ) == -1 ) {
          content[i].filtered = false;
          break;
        }
      }
    } else {
      content[i].filtered = false;
    }
  });
};
